// =====================================================
// Types pour le système de permissions
// =====================================================

export type RoleName = 'vendeur' | 'admin' | 'gerant';

export type MenuCategory = 'navbar' | 'sidebar' | 'homepage';

export type MenuKey =
  // Navbar
  | 'menu_principal'
  | 'ventes'
  | 'listes'
  | 'livraisons'
  | 'statistiques'
  | 'comptabilite'
  | 'ca_du_jour'
  | 'marketing_studio'
  | 'gestion'
  | 'parametres'
  // Sidebar
  | 'home'
  | 'orders'
  | 'products'
  | 'clients'
  | 'deliveries'
  | 'statistics'
  | 'accounting'
  | 'payments'
  // Homepage
  | 'new_order'
  | 'new_quote'
  | 'factures'
  | 'accompte_list'
  | 'credit_notes'
  | 'client_management'
  | 'articles'
  | 'search'
  | 'after_sales'
  | 'deliveries_services'
  // IA
  | 'ai_chat';

export interface MenuPermission {
  id: string;
  role_name: RoleName;
  menu_key: MenuKey;
  menu_category: MenuCategory;
  is_enabled: boolean;
  created_at: string;
  updated_at: string;
}

export interface UserPermissions {
  menu_key: MenuKey;
  menu_category: MenuCategory;
  is_enabled: boolean;
}

export interface MenuDefinition {
  key: MenuKey;
  label: string;
  category: MenuCategory;
  description?: string;
}

// Définition de tous les menus disponibles
export const MENU_DEFINITIONS: MenuDefinition[] = [
  // Navbar
  { key: 'menu_principal', label: 'Menu Principal', category: 'navbar' },
  { key: 'ventes', label: 'Ventes', category: 'navbar' },
  { key: 'listes', label: 'Listes', category: 'navbar' },
  { key: 'livraisons', label: 'Livraisons', category: 'navbar' },
  { key: 'statistiques', label: 'Statistiques', category: 'navbar' },
  { key: 'comptabilite', label: 'Comptabilité', category: 'navbar' },
  { key: 'ca_du_jour', label: 'CA du jour', category: 'navbar' },
  { key: 'marketing_studio', label: 'Marketing Studio', category: 'navbar' },
  {
    key: 'gestion',
    label: 'Gestion',
    category: 'navbar',
    description: 'Réservé aux gérants et administrateurs',
  },
  {
    key: 'parametres',
    label: 'Paramètres',
    category: 'navbar',
    description: 'Réservé au super admin',
  },

  // Sidebar
  { key: 'home', label: 'Accueil', category: 'sidebar' },
  { key: 'orders', label: 'Commandes', category: 'sidebar' },
  { key: 'products', label: 'Articles', category: 'sidebar' },
  { key: 'clients', label: 'Clients', category: 'sidebar' },
  { key: 'deliveries', label: 'Livraisons', category: 'sidebar' },
  { key: 'statistics', label: 'Statistiques', category: 'sidebar' },
  { key: 'accounting', label: 'Calculatrice', category: 'sidebar' },
  { key: 'payments', label: 'Acomptes', category: 'sidebar' },

  // Homepage
  { key: 'new_order', label: 'Nouvelle commande', category: 'homepage' },
  { key: 'new_quote', label: 'Nouveau devis', category: 'homepage' },
  { key: 'factures', label: 'Factures à établir', category: 'homepage' },
  { key: 'accompte_list', label: 'Liste des acomptes', category: 'homepage' },
  { key: 'credit_notes', label: 'Notes de crédit', category: 'homepage' },
  { key: 'client_management', label: 'Gestion clients', category: 'homepage' },
  { key: 'articles', label: 'Articles', category: 'homepage' },
  { key: 'search', label: 'Recherche', category: 'homepage' },
  { key: 'after_sales', label: 'Service après-vente', category: 'homepage' },
  { key: 'deliveries_services', label: 'Livraisons et services', category: 'homepage' },

  // IA
  {
    key: 'ai_chat',
    label: 'Assistant IA',
    category: 'sidebar',
    description: 'Accès au chat IA (rapport, requêtes, emails SAV)',
  },
];

// Super admin email
export const SUPER_ADMIN_EMAIL = 'daniel.gosset@hotmail.com';

// Rôles disponibles
export const ROLES: RoleName[] = ['vendeur', 'admin', 'gerant'];
